import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  codeBox: {
    backgroundColor: theme.palette.code.background,
    borderRadius: theme.shape.borderRadius,
  },
  codeText: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  previewContainer: {
    overflow: 'auto',
    maxHeight: '80vh',
  },
}))

export default styles
